// @flow
import {setLanguageKey} from '@userstory/i18n';
import {ROUTE} from 'app/constants/route';
import cn from 'classnames';
import {useSwitchState} from 'modules/common/hooks/use-switch-state';
import {ReactComponent as BurgerMenuCloseIcon} from 'modules/common/icons/burger-menu-cross.svg';
import {ReactComponent as BurgerMenuIcon} from 'modules/common/icons/burger-menu.svg';
import {ReactComponent as GlobeIcon} from 'modules/common/icons/globe.svg';
import {selectLanguageCodes} from 'modules/common/selectors';
import React from 'react';
import {useIntl} from 'react-intl';
import {useDispatch, useSelector} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import styles from './styles.local.less';

/**
 * Шапка сайта
 * @returns React-компонент
 */
export const AnonymousHeader = () => {
    const intl = useIntl();
    const history = useHistory();
    const dispatch = useDispatch();
    const languageCodes = useSelector(selectLanguageCodes);
    const [isShowLanguages, {toggle: toggleShowLanguages}] = useSwitchState(false);
    const [isShowMenu, {toggle: toggleShowMenu}] = useSwitchState(false);

    /**
     * Функция по изменению языка на стартовом интерфейсе
     * @param e event кнопки по которой нажали
     */
    function changeLang(e) {
        dispatch(setLanguageKey(e.target.id));
    }

    const path = history.location.pathname;
    const toMain = path && '/' === path;

    return (
        <header className={cn(styles.header)}>
            <div>
                <Link className={styles.headerLogo} to="/">
                    <span>cito</span>
                </Link>
            </div>
            <div className={styles.headerRightSide}>
                <div className={styles.headerMenu}>
                    <Link className={styles.headerSignUp} to={`/${ROUTE.AUTH}/sign-up`}>
                        {intl.formatMessage({defaultMessage: 'Sign up', id: 'common.anonymousHeader.registerCompany'})}
                    </Link>
                    <Link className={styles.headerSignIn} to={`/${ROUTE.AUTH}/sign-in`}>
                        {intl.formatMessage({defaultMessage: 'Log on', id: 'common.anonymousHeader.enter'})}
                    </Link>
                </div>
                <div className={cn(styles.headerDropMenu, {[styles.headerLanguagesActive]: isShowMenu})} onClick={toggleShowMenu} role="presentation">
                    {isShowMenu ? <BurgerMenuCloseIcon /> : <BurgerMenuIcon />}
                    <div className={cn({[styles.headerDropDownWrapper]: isShowMenu})}>
                        <div className={cn(styles.wrapperCloseLanguagesPopup)} onClick={toggleShowMenu} role="presentation" />
                        <div className={cn(styles.headerDropDownMenu, {['d_n']: !isShowMenu})}>
                            <Link className={styles.headerSignUpMenu} to={`/${ROUTE.AUTH}/sign-up`}>
                                {intl.formatMessage({defaultMessage: 'Sign up', id: 'common.anonymousHeader.registerCompany'})}
                            </Link>
                            <Link className={styles.headerSignInMenu} to={`/${ROUTE.AUTH}/sign-in`}>
                                {intl.formatMessage({defaultMessage: 'Log on', id: 'common.anonymousHeader.enter'})}
                            </Link>
                        </div>
                    </div>
                </div>
                {!toMain && (
                    <div
                        className={cn(styles.headerLanguages, {[styles.headerLanguagesActive]: isShowLanguages})}
                        onClick={toggleShowLanguages}
                        role="presentation"
                    >
                        <GlobeIcon />
                        <div className={cn({[styles.headerDropDownWrapper]: isShowLanguages})}>
                            <div className={cn(styles.wrapperCloseLanguagesPopup)} onClick={toggleShowLanguages} role="presentation" />
                            <div className={cn(styles.headerDropDown, {['d_n']: !isShowLanguages})}>
                                {languageCodes.map((language) => {
                                    return (
                                        <div
                                            className={cn(styles.headerDropDownItem)}
                                            id={language.code}
                                            key={language.code}
                                            onClick={changeLang}
                                            role="presentation"
                                        >
                                            {language.code}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
};
